import { GFRDashboardNavigation } from '@/components/GFR/GFRDashboardNavigation'
import { DATE_FORMAT } from '@/constants/common.constant'
import { IGfrRiskHistoryDTO } from '@/interfaces/gfrReport.interface'
import { ReportDashboardLayout } from '@/Layouts/ReportDashboardLayout'
import VerticallySplitLayout from '@/Layouts/VerticallySplitLayout'
import {
  clearGFRSummary,
  fetchGFRSummaryAsync,
} from '@/states/axiomReport.slice'
import { AgGridReact } from '@ag-grid-community/react'
import { Loader } from '@components/Base/Loader/Loader'
import GFRHeader from '@components/GFR/GFRHeader'
import { GFRSummaryChart } from '@components/GFR/SummaryReport/GFRSummaryChart'
import { GFRSummaryTable } from '@components/GFR/SummaryReport/GFRSummaryTable'
import { useAppDispatch } from '@hooks/use-app-dispatch'
import { useAppSelector } from '@hooks/use-app-selector'
import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const GFRSummaryPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [gridReference, setGridReference] = useState<AgGridReact>()
  const [rowData, setRowData] = useState<IGfrRiskHistoryDTO[]>([])
  const selectedReport = useAppSelector((s) => s.axiomReport.selectedReport)
  const gfrSummary = useAppSelector((s) => s.axiomReport.gfrReport.summary)
  const showLoader = useAppSelector((s) => s.axiomReport.showLoader)

  useEffect(() => {
    if (
      Object.keys(selectedReport).length &&
      selectedReport.reportType === 'GFR'
    ) {
      dispatch(
        fetchGFRSummaryAsync(
          selectedReport.reportId,
          dayjs(selectedReport.endDate)
            .subtract(90, 'day')
            .format(DATE_FORMAT.API),
          dayjs(selectedReport.endDate).format(DATE_FORMAT.API),
        ),
      )
    } else {
      navigate('/')
    }
  }, [selectedReport])

  useEffect(() => {
    gfrSummary && gfrSummary.length && setRowData(gfrSummary)
  }, [gfrSummary])

  useEffect(() => {
    return () => {
      dispatch(clearGFRSummary())
    }
  }, [])

  return (
    <ReportDashboardLayout
      selectedReport={selectedReport}
      navigation={<GFRDashboardNavigation />}
    >
      {showLoader ? (
        <Loader />
      ) : (
        <VerticallySplitLayout
          contentTop={<GFRSummaryChart chartData={rowData} />}
          contentBottom={
            <GFRSummaryTable
              rowData={rowData}
              setGridReference={setGridReference}
            />
          }
          headerTop={<Typography variant='h4'>90-Day Risk History</Typography>}
          headerBottom={
            <GFRHeader
              reportData={selectedReport}
              gridReference={gridReference as AgGridReact}
            />
          }
        />
      )}
    </ReportDashboardLayout>
  )
}
